import { Card } from '@platform/design-system';
import type { TypedClient } from '@platform/openapi';
import { useState } from 'react';
import type { MovementState } from '../../inventory/inventory.ts';
import { InventoryMovements } from '../../inventory/InventoryMovements.tsx';
import { useActiveLocations } from '../../inventory/useStockMatrix.ts';
import { usePageContext } from '../../usePageContext.ts';

export type ProductMovementsProps = { api: TypedClient; productId: string };

export const ProductMovements = ({ api, productId }: ProductMovementsProps) => {
  const { t } = usePageContext();
  const [state, setState] = useState<MovementState | null>(null);
  const [depot, setDepot] = useState<string | null>(null);
  const locations = useActiveLocations(api).data?.items ?? [];
  return (
    <Card title={t('productStatistics.historyTitle')}>
      <InventoryMovements
        api={api}
        locations={locations}
        state={state}
        depot={depot}
        productId={productId}
        onStateChange={setState}
        onDepotChange={setDepot}
        onPrintLabels={null}
      />
    </Card>
  );
};
